import { render, staticRenderFns } from "./ProviderProfileLayout.vue?vue&type=template&id=49fc38b4&scoped=true&"
import script from "./ProviderProfileLayout.vue?vue&type=script&lang=js&"
export * from "./ProviderProfileLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProviderProfileLayout.vue?vue&type=style&index=0&id=49fc38b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc38b4",
  null
  
)

component.options.__file = "ProviderProfileLayout.vue"
export default component.exports